<template>
  <v-chip class="ma-2" :color="status.color" dark>{{ status.text }}</v-chip>
</template>

<script>
export default {
  name: "wapi-status",
  props: {
    value: [Number, Boolean]
  },
  data() {
    return {};
  },
  computed: {
    status() {
      if (typeof this.value == "number") {
        switch (this.value) {
          case 1:
            return { color: "green", text: "Активный" };
          case 0:
            return { color: "red", text: "Не активный" };
          default:
            return { color: "", text: "Неопределен" };
        }
      }

      if (this.value) {
        return { color: "green", text: "Активный" };
      }
      return { color: "red", text: "Не активный" };
    }
  }
};
</script>